import React from 'react';
import PropTypes from 'prop-types';
import { VStack, Text } from '@chakra-ui/react';

import { cn } from '@rsc/tailwind-base/utils';
import { LocalizedLink } from '@rsc/gatsby-localization-helpers';
import menuCollectionSorter from '../../../layout/Header/menuCollectionSorter';

export default function CurrentGroup({ currentGroup }) {
  return (
    <VStack align="flex-start" mb="10">
      <Text
        className={`leading-tight text-foreground no-underline hover:underline font-bold pl-2 ${
          currentGroup.parentCollection.active
            ? 'border-l-ring'
            : 'border-l-transparent'
        } border-l-2 border-l-solid`}
        as={currentGroup.parentCollection.active ? 'p' : LocalizedLink}
        to={`/${currentGroup.parentCollection.pathname}`}
      >
        {currentGroup.parentCollection.title}
      </Text>
      {menuCollectionSorter(
        currentGroup.parentCollection?.store?.title,
        currentGroup
      ).childCollections?.map(c => (
        <Text
          className={cn(
            'leading-tight text-foreground no-underline hover:underline text-sm ml-4 pl-2 border-l-2 border-l-solid',
            c.active
              ? 'border-l-ring font-normal hover:no-underline'
              : 'border-l-transparent font-light'
          )}
          key={c._id}
          as={c.active ? 'p' : LocalizedLink}
          to={`/${c.pathname}`}
        >
          {c.title}
        </Text>
      ))}
    </VStack>
  );
}

CurrentGroup.propTypes = {
  currentGroup: PropTypes.shape({
    parentCollection: PropTypes.shape({
      title: PropTypes.string.isRequired,
      pathname: PropTypes.string.isRequired,
      active: PropTypes.bool,
      store: PropTypes.shape({
        title: PropTypes.string.isRequired,
      }),
    }).isRequired,
    childCollections: PropTypes.arrayOf(
      PropTypes.shape({
        _id: PropTypes.string.isRequired,
        active: PropTypes.bool,
        pathname: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
      })
    ).isRequired,
  }).isRequired,
};
